module.exports = __webpack_public_path__ + "static/media/searched-by-fam-check.c67712fa.svg";